import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, TextField, Typography } from "@mui/material";
import React from "react";
import dayjs, { Dayjs } from 'dayjs';
import { DatePicker } from "@mui/x-date-pickers";
import CloudIcon from '@mui/icons-material/Cloud';
import useStudy from "../hooks/useStudy";
import { useNavigate } from "react-router-dom";
const getLastDayOfMonth = (date) => {
    return dayjs(date).endOf('month');
};
const NEW_FORM_DATA = {
    apiList: "",
    refracDate: getLastDayOfMonth(dayjs()),
    name: ""
};
const NewStudyPage = () => {
    const [formData, setFormData] = React.useState(NEW_FORM_DATA);
    const navigate = useNavigate();
    const { submitStudy } = useStudy();
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            console.log("Form data looks like this: ", formData);
            const submitStudyReponse = await submitStudy(formData);
            console.log("Submit Study Response: ", submitStudyReponse["studyUuid"]);
            navigate('/studies/' + submitStudyReponse["studyUuid"]);
        }
    };
    const validate = () => {
        return true;
    };
    const onFormChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const resetFormData = () => {
        console.log("resetting form data");
        setFormData(NEW_FORM_DATA);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h4", sx: { marginBottom: "24px" }, children: "New Study" }), _jsxs(Box, { component: "form", onSubmit: handleSubmit, id: "setup-form", sx: { width: "45%", display: "flex", flexDirection: "column", gap: "24px", padding: "32px 16px", borderRadius: "10px", backgroundColor: "white" }, children: [_jsx(Box, { id: "user-input", sx: { display: "flex", flexDirection: "column", gap: '32px' }, children: _jsx(Typography, { variant: "h5", children: "Setup" }) }), _jsxs(Box, { id: "form-inputs", sx: { display: "flex", flexDirection: "column", gap: '32px' }, children: [_jsx(TextField, { variant: "outlined", multiline: true, rows: 8, label: "Enter List of APIs", value: formData.apiList, helperText: "Please separate APIs with commas", name: "apiList", onChange: onFormChange, required: true, slotProps: {
                                    inputLabel: {
                                        "variant": "outlined",
                                        "color": "blueGray",
                                        "focused": true,
                                        "disableAnimation": true,
                                        "required": true,
                                        "shrink": true
                                    },
                                    formHelperText: {
                                        "variant": "outlined",
                                        "focused": true,
                                        "required": true,
                                    },
                                } }), _jsx(TextField, { variant: "outlined", label: "Name", value: formData.name, name: "name", onChange: onFormChange, required: true, slotProps: {
                                    inputLabel: {
                                        "variant": "outlined",
                                        "color": "blueGray",
                                        "focused": true,
                                        "disableAnimation": true,
                                        "required": true,
                                        "shrink": true
                                    },
                                    formHelperText: {
                                        "variant": "outlined",
                                        "focused": true,
                                        "required": true,
                                    }
                                } }), _jsx(DatePicker, { label: "ReFrac Date", openTo: "month", views: ["year", "month"], name: "refracDate", value: formData.refracDate, onChange: (date) => {
                                    if (date) {
                                        setFormData({ ...formData, refracDate: dayjs(date) });
                                    }
                                }, disablePast: true, slotProps: {
                                    textField: {
                                        InputLabelProps: {
                                            "variant": "outlined",
                                            "color": "blueGray",
                                            "focused": true,
                                            "disableAnimation": true,
                                            "required": true,
                                            "shrink": true
                                        }
                                    }
                                } })] }), _jsx(Box, { id: "form-buttons", children: _jsxs(Box, { sx: {
                                display: "flex",
                                flexDirection: "row",
                                flexGrow: 1,
                                gap: '24px',
                            }, children: [_jsx(Button, { sx: { flexBasis: 0, flexGrow: 1 }, type: "submit", startIcon: _jsx(CloudIcon, {}), size: "large", color: "primary", variant: "contained", onSubmit: handleSubmit, children: "Begin Study" }), _jsx(Button, { sx: { flexBasis: 0, flexGrow: 1 }, size: "large", color: "primary", variant: "text", type: "button", onClick: resetFormData, children: "Clear All" })] }) })] })] }));
};
export default NewStudyPage;
